import BackLink from '../navigation/BackLink.jsx';
import useScreen from '../hooks/useScreen.js';

// The dedicated-screen header as one component: an optional back link, the
// focused h1 (id="main-content", the per-screen a11y wiring in useScreen) and a
// muted sub-line. The earlier screens spell this markup out inline; the help
// section's screens share it, as does the web stand-in for the app's Header
// (shims/appCommon.jsx), so an app screen rendered in place gets the same header
// every web screen has.
export default function ScreenHeader({
  title,
  sub,
  backTo,
  backLabel = 'Back',
  children,
}) {
  const headingRef = useScreen(typeof title === 'string' ? title : '');
  return (
    <header className="screen__header">
      {backTo ? <BackLink to={backTo} label={backLabel} /> : null}
      <h1 id="main-content" tabIndex={-1} ref={headingRef}>
        {title}
      </h1>
      {sub ? <p className="screen__sub">{sub}</p> : null}
      {children}
    </header>
  );
}
